import React, { useEffect, useState } from "react";
import { Table } from "antd";
import axios from "axios";
import { folioColumns } from "../columns/folioColumns";
import { LedgerResponsiveWrapper, API_BASE, getArn } from "../LedgerResponsive";
import SchemeTable from "./SchemeTable";

export default function FolioTable({ pan, onOpenModal, onOpenSchemeModal, onOpenTxnModal }) {
  const [folios, setFolios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pan) return;
    setLoading(true);

    axios
      .get(`${API_BASE}/get_folios.php?pan=${pan}&arn_no=${getArn()}`)
      .then((res) => {
        console.log("👉 Raw Folios API Response:", res.data);
        if (res.data && Array.isArray(res.data.folios)) {
          setFolios(res.data.folios);
        } else {
          setFolios([]);
        }
      })
      .catch((err) => {
        console.error("❌ Folios API Error:", err);
        setFolios([]);
      })
      .finally(() => setLoading(false));
  }, [pan]);

  console.log("👉 Final folios state:", folios);

  return (
    <LedgerResponsiveWrapper>
      <Table
        loading={loading}
        columns={folioColumns(onOpenModal)}
        dataSource={folios}
        rowKey="folio_number"
        pagination={false}
        bordered
        expandable={{
          expandedRowRender: (record) => (
            <SchemeTable
              folio={record.folio_number}
              pan={pan}
              onOpenModal={onOpenSchemeModal}
              onOpenTxnModal={onOpenTxnModal}
            />
          ),
          rowExpandable: () => true,   // ✅ force expand sign always
        }}
      />
    </LedgerResponsiveWrapper>
  );
}
